import artwork103213 from "../../../assets/curation/1/103213.jpg";
import artwork11455 from "../../../assets/curation/1/11455.jpg";
import artwork144796 from "../../../assets/curation/1/144796.jpg";
import artwork108283 from "../../../assets/curation/1/108283.png";
import artwork20051 from "../../../assets/curation/1/20051.jpg";
import artwork167476 from "../../../assets/curation/1/167476.png";
import artwork177085 from "../../../assets/curation/1/177085.jpg";
import artwork70468 from "../../../assets/curation/1/70468.jpg";
import artwork122143 from "../../../assets/curation/1/122143.png";
import artwork57046 from "../../../assets/curation/1/57046.jpg";
import artwork152848 from "../../../assets/curation/1/152848.jpg";
import artwork174667 from "../../../assets/curation/1/174667.jpg";
import artwork181712 from "../../../assets/curation/1/181712.jpg";

const data = {
  title: "Fogo-fátuo",
  subtitle: "PRISMA #2",
  curated: "Curated by<br/>Mariana Destro",
  description: `
  Fogo-fátuo is an atmospheric ghost light seen at night, especially over wetlands. In Brazil, it’s also known as boitatá, a gargantuan fire snake that protects the woods from those who burn it. 
  <br/>A wisp of fire glowing within the dark… Right now it feels like a fitting metaphor for the future. To quote Ailton Krenak, even though a shared idea of time lacks the meaning of self and society, different kinds of people still dance, sing, and manifest visions of times to come.
  `,
  artists: [
    {
      artist: ["Hung Yu Hao"],
      title: "Trigger in City#3",
      profile: ["tz1TtUyR5URy2rGZS9pV8JT8TuhixiEPf3xF"],
      description:
        "I use memories from the 90s to recall the alley that were demolished. Where the sale of many appliances, especially TV. The alley went from the most prosperous to the most withered over time.",
      objktID: 103213,
      artwork: artwork103213,
    },
    {
      artist: ["Mari Nagem"],
      title: "Cryptonudes",
      profile: ["tz1gg93yFLGUXM6vUajgr4URvQNyCkKv6x3D"],
      description:
        "Send nudes. How to break body-normativity throughout the digital",
      objktID: 57046,
      artwork: artwork57046,
    },
    {
      artist: ["Amanda Devulsky"],
      title: "Picture 200.jpg 15/06/2004 21:54 #22",
      profile: ["tz1d8ukZmLdptnm5KzY6BP1qaWocwpmFswig"],
      description:
        "digital archive from Tuesday 15 June 2004 21:54 480×640 jpeg / Ultrasuperfície 2003-2005 ultrasuperficie.net now on view at aarea.co",
      objktID: 177085,
      artwork: artwork177085,
    },
    {
      artist: ["CIPOTE"],
      title: "FRESH BOUQUET",
      profile: ["tz1dkbW1gfztn5yQotoE2ntkiBQDcwGqp9os"],
      description: `fresh flowers, just for you. 

        xxxx
        
        VHS footage run through shader, analog video mixer & video feedback device. 
        
        .GIF [1024x768]
        `,
      objktID: 174667,
      artwork: artwork174667,
    },
    {
      artist: ["Adriana Lup", "Carsten Bund"],
      title: "Synthesized Beauty 1",
      profile: ["", "tz1dg7mtTtYUNXAFMbWmVB1Aw9wwF7umT7Hy"],
      description: "DCGAN Colab between Adriana Lup and Carsten Bund 1",
      objktID: 20051,
      artwork: artwork20051,
    },
    {
      artist: ["Yluztra"],
      title: "KORAL #5",
      profile: ["tz1NcMLkFhHGnfCch4GX5nSGJ6pY7797iofp"],
      description: "Koral Series NFT, by @yluztra.",
      objktID: 70468,
      artwork: artwork70468,
      multiple: true,
    },
    {
      artist: ["Amanda Devulsky"],
      title: "P4080188.jpg 08/04/2005 03:36 #7",
      profile: ["tz1d8ukZmLdptnm5KzY6BP1qaWocwpmFswig"],
      description:
        "digital archive from Friday 8 April 2005 03:36 2288 × 1712 pixels jpeg / Ultrasuperfície 2003-2005 ultrasuperficie.net now on view at aarea.co",
      objktID: 152848,
      artwork: artwork152848,
      multiple: true,
    },
    {
      artist: ["Eduardo Moreira"],
      title: "when I sleep",
      profile: ["tz1RP2JCzGLH2xCXhue5oirjrFB1Zdu8E5vm"],
      description:
        "3d artwork about my spiritual connection to the ocean and my love for boluminescent life. Eduardo Moreira, 2021, 1080x1080px.",
      objktID: 11455,
      artwork: artwork11455,
    },
    {
      artist: ["Yluztra"],
      title: "KORAL #8",
      profile: ["tz1NcMLkFhHGnfCch4GX5nSGJ6pY7797iofp"],
      description: "Koral Series NFT, by @yluztra.",
      objktID: 108283,
      artwork: artwork108283,
    },
    {
      artist: ["L U R E X"],
      title: "ily HEN",
      profile: ["tz1XtiehKSykKrjP9KDETKShrAqKPzQKnDWs"],
      description: "celebrating 100 days of HEN ♥",
      objktID: 122143,
      artwork: artwork122143,
    },
    {
      artist: ["Thiago Granai"],
      title: "Swiss cheese model of accident causation",
      profile: ["tz1dautEEkVnWBTmKNfeM6XjoLsw9sXA1Hdj"],
      description: `3D artwork of James Reason's swiss cheese model of accident causation. A piece of videoart "Ilhas de edição" (2020) by Thiago Granai (@granaithiago).`,
      objktID: 181712,
      artwork: artwork181712,
    },
    {
      artist: ["Kinnara : Desi La"],
      title: "Fractal Reflections 1",
      profile: ["tz1RHeMFfMYVwkgwY17rAPVxsjVjK9X5NhFE"],
      description:
        "One of numerous unseen works that were made during the making of Dead Machine at the beginning of my visual arts career.",
      objktID: 167476,
      artwork: artwork167476,
    },
    {
      artist: ["Non-fungible Visions"],
      title: "#2 - Reminiscence",
      profile: ["tz1LHPzztU6uRyzDhQUGLHbf3T8ehSJid1fc"],
      description: "",
      objktID: 144796,
      artwork: artwork144796,
    },
  ],
};

export default data;
